<template>
    <div class="grid w-100 h-100 d-flex justify-content-center align-items-center flex-row">
		<div class="cylinder-container w-60 h-100 d-flex align-items-center justify-content-center flex-column">
			<p class="info-text text-success"> {{info.maximum}} </p>
			<div class="cylinder" ref="cylinder">
				<div class="fill" :style="[barColor, fillHeight]"></div>
			</div>
			<p class="text-danger info-text m-16"> {{info.minimum}} </p>
		</div>
		<div class="info text-center w-40 ">
			<h6> {{value}} {{unit}} </h6>
		</div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            cylinderHeight: 20
        }
    },
    props:{
		value: {
			type: Number,
			required: false,
			default: 80,
		},
		info:{
			type: Object,
			required: true
		},
		fullscreen:{
			required:false,
			type:Boolean,
			default:false,
		},
		divisionsColorList:{
			type: Array,
			required:true
		}
	},
    computed:{
        unit(){
            return this.info.unit ? this.info.unit : 'unidade'
        },
		min(){
			return this.info.minimum != undefined ? this.info.minimum : 0
		},
		max(){
			return this.info.maximum  != undefined ? this.info.maximum : 100
		},
		getPercentage() {
            let valor = Math.max(this.min, Math.min(this.value, this.max));

            const intervalo = this.max - this.min;
            const porcentagem = ((valor - this.min) / intervalo) * 100;

            return porcentagem;
        },

		/**Ajusta a altura do 'preenchimento' do cilindro */
        fillHeight(){
			console.log(this.cylinderHeight);
			var cylinderRange = this.cylinderHeight - 38;
            var height = (cylinderRange * (this.getPercentage / 100)) + 38
            return {'--fill-height': `${height}px`}
        },

		/**Gera gradiente do cilindro */
        barColor(){

			return {
                "--barColor": this.divisionsColorList[0].color
            }
		},
    },
    methods:{
        resizeMeasurer(){
			// Verifica se existe o elemento do cilindro criado
            if(this.$refs.cylinder) this.cylinderHeight = this.$refs.cylinder.offsetHeight
        }
    },
    mounted(){
        setTimeout(()=>{
            this.resizeMeasurer()
        }, 1000)
    }

}
</script>

<style scoped>

.text-center{
	height: auto;
	margin-right: 10px;
	font-size: larger;
}

.info-text{
	opacity: 1;
	font-weight: 300;
	font-size: medium;
	margin: 0;
}

.cylinder-container{
	width: 50%;
}


.cylinder {
	position: relative;
	overflow: hidden;
	margin: 0 auto;
	width: 65%;
	height: 70%;
	min-height: 8rem;
	border-radius: 50px/25px;
	background-color: rgba(160, 160, 160, 0.5);
	border: 1px solid #959595;
}

/* topo do cilindro */
.cylinder:before {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 38px;
	border-radius: 60px/25px;
	background-color: rgba(190, 184, 184, 0.2);
	content: '';
	border: 1px solid #959595;
}
/* fundo do cilindro */
.cylinder:after {
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 38px;
	border-radius: 60px/25px;
	background-color: rgba(190, 184, 184, 0.2);
	content: '';
	border: 1px solid #959595;
}

.fill {
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: var(--fill-height);
	border-radius: 80px/25px;
	background: var(--barColor);
	/* background: pink; */
    /* : 0.5; */
    opacity: 0.5;
	transition: 0.3s linear;
}

/* Topo do conteudo */
.fill:before {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 35px;
	border-radius: 80px/25px;
    /* 0.2  */
    opacity: 0.5;
	background-color: #cbcfd3;
	content: '';
	border: 1.5px solid rgb(155, 154, 154);
}

/* Parte de baixo */
.fill:after { 
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 50px;
	border-radius: 50px/25px;
    /* 0.4 */
    opacity: 0;
	/* background-color: var(--bottomColor); */
	content: '';
}

</style>